import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ConsentPage from "./pages/ConsentPage";
import { Toaster } from "sonner";
import CookieBanner from "@/components/CookieBanner";
import YandexMetrica from "@/components/YandexMetrica";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/consent" element={<ConsentPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#120F0D",
            border: "1px solid rgba(229,115,36,0.4)",
            color: "#F2E9DE",
            borderRadius: 0,
            fontFamily: "'Outfit', sans-serif",
          },
        }}
      />
      <CookieBanner />
      <YandexMetrica />
    </div>
  );
}

export default App;
